import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { ProtectedElement as ProtectedElement$1 } from '@praxis/component-auth';
import Unauthorized from '../Unauthorized/Unauthorized.js';

var _excluded = ["allowed"];

// Provides a wrapper over praxis ProtectedElement with Unauthorized component inbuilt
var ProtectedElement = function ProtectedElement(_ref) {
  var allowed = _ref.allowed,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ProtectedElement$1, _extends({
    allowed: allowed,
    renderUnauthorized: function renderUnauthorized() {
      return /*#__PURE__*/React.createElement(Unauthorized, {
        requiredAccess: allowed
      });
    }
  }, restProps));
};

export { ProtectedElement as default };
